import { Component } from '@angular/core';
import { ViewController, NavParams, ToastController } from 'ionic-angular';

// Antes
// interface Trabajador { id: number; nombre: string; }
// sourceId: number | null = null;
// destSel = new Set<number>();
// isDst(id: number): boolean { ... }
// toggleDst(id: number, checked: boolean) { ... }

// Después
interface Trabajador { id: string; nombre: string; }


@Component({
  selector: 'modal-copiar-patron',
  templateUrl: 'mod-copiar-patron.html'
})
export class CopiarPatronModal {
  trabajadores: Trabajador[] = [];


  filtroSrc = '';
  filtroDst = '';

  sourceId: string | null = null;
  destSel = new Set<string>();
  


  usarDiasSel: boolean = false;
  diasSel: string[] = [];

  constructor(private vc: ViewController, private nav: NavParams, private toast: ToastController) {
    this.trabajadores = this.nav.get('trabajadores') || [];
    this.usarDiasSel = !!this.nav.get('usarDiasSel');
    this.diasSel = this.nav.get('diasSel') || [];
  }

  cerrar() { this.vc.dismiss({ ok: false }); }

  isDst(id: string): boolean { return this.destSel.has(id); }
  toggleDst(id: string, checked: boolean) { if (checked) this.destSel.add(id); else this.destSel.delete(id); }


  confirmar() {
    if (!this.sourceId || this.destSel.size === 0) {
      this.toast.create({ message: 'Elige un origen y al menos un destino', duration: 1400 }).present();
      return;
    }
    this.vc.dismiss({
      ok: true,
      sourceId: this.sourceId,
      destIds: Array.from(this.destSel),
      usarDiasSel: this.usarDiasSel
    });
  }

  listaSrc(): Trabajador[] {
    const q = (this.filtroSrc || '').toLowerCase().trim();
    if (!q) return this.trabajadores;
    const out: Trabajador[] = [];
    for (let i = 0; i < this.trabajadores.length; i++) {
      const t = this.trabajadores[i];
      if ((t.nombre || '').toLowerCase().indexOf(q) !== -1) out.push(t);
    }
    return out;
  }

  listaDst(): Trabajador[] {
    const q = (this.filtroDst || '').toLowerCase().trim();
    if (!q) return this.trabajadores;
    const out: Trabajador[] = [];
    for (let i = 0; i < this.trabajadores.length; i++) {
      const t = this.trabajadores[i];
      if ((t.nombre || '').toLowerCase().indexOf(q) !== -1) out.push(t);
    }
    return out;
  }

}



// WEBPACK FOOTER //
// ./src/pages/asignar/mod-copiar-patron.ts